import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  const navItems = [
    { name: 'Home', href: '/' },
    { name: 'Brand Capital', href: '/brand-capital' },
    { name: 'Servizi', href: '/servizi' },
    { name: 'Perché Valorizzare', href: '/perche-valorizzare' },
    { name: 'Case Study', href: '/case-study' },
    { name: 'Risorse', href: '/risorse' },
    { name: 'FAQ', href: '/faq' },
  ];

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const isActive = (path: string) => location.pathname === path;

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-md' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20 sm:h-24 lg:h-32">
          <Link to="/" className="flex items-center">
            <img
              src="https://static.readdy.ai/image/fab5168e291508d3586d4b84ed71e8b7/46cb40e7b05280b560bcee6a29da1570.png"
              alt="Brand Capital"
              className="h-14 sm:h-20 lg:h-24 w-auto object-contain"
            />
          </Link>

          {/* Desktop Menu */}
          <div className="hidden lg:flex items-center gap-8">
            <Link
              to="/"
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                isActive('/')
                  ? 'text-[#E879F9]'
                  : isScrolled
                  ? 'text-[#0B1F3B] hover:text-[#22C55E]'
                  : 'text-white hover:text-[#22C55E]'
              }`}
            >
              Home
            </Link>
            <Link
              to="/brand-capital"
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                isActive('/brand-capital')
                  ? 'text-[#E879F9]'
                  : isScrolled
                  ? 'text-[#0B1F3B] hover:text-[#22C55E]'
                  : 'text-white hover:text-[#22C55E]'
              }`}
            >
              Brand Capital
            </Link>
            <Link
              to="/bci"
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                isActive('/bci')
                  ? 'text-[#E879F9]'
                  : isScrolled
                  ? 'text-[#0B1F3B] hover:text-[#22C55E]'
                  : 'text-white hover:text-[#22C55E]'
              }`}
            >
              BCI
            </Link>
            <Link
              to="/servizi"
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                isActive('/servizi')
                  ? 'text-[#E879F9]'
                  : isScrolled
                  ? 'text-[#0B1F3B] hover:text-[#22C55E]'
                  : 'text-white hover:text-[#22C55E]'
              }`}
            >
              Servizi
            </Link>
            <Link
              to="/case-study"
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                isActive('/case-study')
                  ? 'text-[#E879F9]'
                  : isScrolled
                  ? 'text-[#0B1F3B] hover:text-[#22C55E]'
                  : 'text-white hover:text-[#22C55E]'
              }`}
            >
              Case Study
            </Link>
            <Link
              to="/risorse"
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                isActive('/risorse')
                  ? 'text-[#E879F9]'
                  : isScrolled
                  ? 'text-[#0B1F3B] hover:text-[#22C55E]'
                  : 'text-white hover:text-[#22C55E]'
              }`}
            >
              Risorse
            </Link>
            <Link
              to="/perche-valorizzare"
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                isActive('/perche-valorizzare')
                  ? 'text-[#E879F9]'
                  : isScrolled
                  ? 'text-[#0B1F3B] hover:text-[#22C55E]'
                  : 'text-white hover:text-[#22C55E]'
              }`}
            >
              Perché Valorizzare
            </Link>
            <Link
              to="/faq"
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                isActive('/faq')
                  ? 'text-[#E879F9]'
                  : isScrolled
                  ? 'text-[#0B1F3B] hover:text-[#22C55E]'
                  : 'text-white hover:text-[#22C55E]'
              }`}
            >
              FAQ
            </Link>
            <Link
              to="/contatti"
              className={`px-6 py-2.5 rounded-md text-sm font-medium transition-all whitespace-nowrap cursor-pointer ${
                isScrolled
                  ? 'bg-[#E879F9] text-white hover:bg-[#E879F9]/90'
                  : 'bg-[#E879F9] text-white hover:bg-[#E879F9]/90'
              }`}
            >
              Contatti
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className={`lg:hidden p-2 rounded-md cursor-pointer ${
              isScrolled ? 'text-[#0B1F3B]' : 'text-white'
            }`}
          >
            <i className={`${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl`}></i>
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="lg:hidden bg-white shadow-lg rounded-b-lg">
            <div className="px-4 py-6 space-y-4">
              <Link
                to="/"
                onClick={() => setIsMobileMenuOpen(false)}
                className={`block text-base font-medium transition-colors cursor-pointer ${
                  isActive('/') ? 'text-[#E879F9]' : 'text-[#0B1F3B] hover:text-[#22C55E]'
                }`}
              >
                Home
              </Link>
              <Link
                to="/brand-capital"
                onClick={() => setIsMobileMenuOpen(false)}
                className={`block text-base font-medium transition-colors cursor-pointer ${
                  isActive('/brand-capital') ? 'text-[#E879F9]' : 'text-[#0B1F3B] hover:text-[#22C55E]'
                }`}
              >
                Brand Capital
              </Link>
              <Link
                to="/bci"
                onClick={() => setIsMobileMenuOpen(false)}
                className={`block text-base font-medium transition-colors cursor-pointer ${
                  isActive('/bci') ? 'text-[#E879F9]' : 'text-[#0B1F3B] hover:text-[#22C55E]'
                }`}
              >
                BCI
              </Link>
              <Link
                to="/servizi"
                onClick={() => setIsMobileMenuOpen(false)}
                className={`block text-base font-medium transition-colors cursor-pointer ${
                  isActive('/servizi') ? 'text-[#E879F9]' : 'text-[#0B1F3B] hover:text-[#22C55E]'
                }`}
              >
                Servizi
              </Link>
              <Link
                to="/case-study"
                onClick={() => setIsMobileMenuOpen(false)}
                className={`block text-base font-medium transition-colors cursor-pointer ${
                  isActive('/case-study') ? 'text-[#E879F9]' : 'text-[#0B1F3B] hover:text-[#22C55E]'
                }`}
              >
                Case Study
              </Link>
              <Link
                to="/risorse"
                onClick={() => setIsMobileMenuOpen(false)}
                className={`block text-base font-medium transition-colors cursor-pointer ${
                  isActive('/risorse') ? 'text-[#E879F9]' : 'text-[#0B1F3B] hover:text-[#22C55E]'
                }`}
              >
                Risorse
              </Link>
              <Link
                to="/perche-valorizzare"
                onClick={() => setIsMobileMenuOpen(false)}
                className={`block text-base font-medium transition-colors cursor-pointer ${
                  isActive('/perche-valorizzare') ? 'text-[#E879F9]' : 'text-[#0B1F3B] hover:text-[#22C55E]'
                }`}
              >
                Perché Valorizzare
              </Link>
              <Link
                to="/faq"
                onClick={() => setIsMobileMenuOpen(false)}
                className={`block text-base font-medium transition-colors cursor-pointer ${
                  isActive('/faq') ? 'text-[#E879F9]' : 'text-[#0B1F3B] hover:text-[#22C55E]'
                }`}
              >
                FAQ
              </Link>
              <Link
                to="/contatti"
                onClick={() => setIsMobileMenuOpen(false)}
                className="block w-full px-6 py-3 bg-[#E879F9] text-white text-center rounded-md text-base font-medium transition-all cursor-pointer hover:bg-[#E879F9]/90"
              >
                Contatti
              </Link>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
}
